<template>
  <div class="rules-container">
    <Modal
      title
      v-model="showPay"
      @on-cancel="close"
      width="530"
      class-name="vertical-center-modal rules-modal"
    >
      <div class="title">请选择支付方式</div>
      <div class="pay-list">
        <div
          v-if="!isWeixin"
          @click="changePayway(0)"
          :class="['item',paymethod==0?'selected':'','ipay']"
        >
          <img class="imgs" src="../../assets/image/icon/ipay.png" />
        </div>
        <div
          @click="changePayway(1)"
          :class="['item',paymethod==1?'selected':'', 'wechat',isWeixin?'only-wechat':'a']"
        >
          <img class="imgs" src="../../assets/image/icon/wechat.png" />
        </div>
      </div>
      <div class="btn" @click="goPay">
        <div>立即支付</div>
        <img class="icon" src="../../assets/image/icon/shop-cart-right.svg" />
      </div>
    </Modal>
  </div>
</template>

<script>
export default {
  name: "DeliveryRules",
  data() {
    return {
      isWeixin: false,
      visitStatus: false
    };
  },
  props: {
    showPay: {
      type: Boolean,
      default: false
    },
    paymethod: {
      type: null,
      default: 0
    }
  },
  mounted() {
    var ua = window.navigator.userAgent.toLowerCase();
    if (ua.match(/MicroMessenger/i) == "micromessenger") {
      this.isWeixin = true;
    }
  },
  components: {},
  methods: {
    goRouter(_r) {
      this.$router.push({ path: _r });
    },
    changePayway(e) {
      this.$emit("payMethod", e);
    },
    close() {
      this.$emit("close");
    },
    goPay() {
      this.$emit("goPay");
    }
  }
};
</script>
<style lang="less" scoped>
.part-container {
  padding-top: 3rem;
}
/deep/.rules-modal .ivu-modal-content {
  width: 53rem;
  // min-height: 25rem;
  padding: 2rem 2rem 4rem;
  margin: 0 auto;
  text-align: left;

  color: #5c5d5f;
}
/deep/.rules-modal .ivu-modal-body {
  padding: 0;
  line-height: 1.2;
  font-size: 1.2rem;
  .pay-list {
    display: flex;
    margin: 2rem 0 2rem;
    .item {
      width: 50%;
      height: 5.8rem;
      line-height: 5.8rem;
      border: 0.1rem solid #959595;
      display: flex;
      justify-content: center;
      align-items: center;
      cursor: pointer;
      &.selected {
        border: 1px solid #92b98c;
      }
      &.ipay {
        img {
          width: 7.8rem;
          height: 2.8rem;
        }
      }
      &.wechat {
        margin-left: 2rem;
        &.only-wechat {
          margin-left: 0;
          width: 100%;
        }
        img {
          width: 2.8rem;
          height: 2.8rem;
        }
      }
    }
  }
}

/deep/.ivu-modal-close {
  display: initial;
}
/deep/.ivu-modal {
  margin: 10px 0;
}
@media screen and (max-width: 1024px) {
  /deep/.rules-modal .ivu-modal-content {
    width: calc(100% - 4rem);
    min-height: 15rem;
  }
}
@media screen and (max-width: 768px) {
  /deep/ .rules-modal .ivu-modal-content {
    width: 100%;
    padding: 2rem;
  }
}
</style>


// WEBPACK FOOTER //
// src/components/common/PayPop.vue